// For Velo API Reference documentation visit http://wix.to/94BuAAs
// To learn about widget code visit http://wix.to/bYYlE3S
import wixWindowFrontend from 'wix-window-frontend';
// import { getCountryCode } from 'backend/wix-request';
import { getCountryCode } from 'public/get-country-frontened';

$w.onReady(async function () {
    let userCountryCode = undefined
    if (wixWindowFrontend.formFactor !== 'Desktop' && $widget.props.Mobile) {
        userCountryCode = await getCountryCode();
    }
    console.log({ userCountryCode });
    $w('#customElement').setAttribute('props', JSON.stringify({
        Desktop: $widget.props.Desktop,
        Mobile: $widget.props.Mobile,
        Tablet: $widget.props.Tablet,
        studio: $widget.props.Studio,
        logo: $widget.props.Logo,
        includedCountryCode: $widget.props.includedCountryCode,
        userCountryCode,
        formFactor: wixWindowFrontend.formFactor
    }));
});

$widget.onPropsChanged((oldProps, newProps) => {
    // If your widget has properties, onPropsChanged is where you should handle changes to their values.
    // Property values can change at runtime by code written on the site, or when you preview your widget here in the App Builder.
});